import { render, staticRenderFns } from "./FieldAlternateSentence.vue?vue&type=template&id=4ec01dca&scoped=true&"
import script from "./FieldAlternateSentence.vue?vue&type=script&lang=ts&"
export * from "./FieldAlternateSentence.vue?vue&type=script&lang=ts&"
import style0 from "./FieldAlternateSentence.vue?vue&type=style&index=0&id=4ec01dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec01dca",
  null
  
)

export default component.exports